module.exports = __webpack_public_path__ + "static/vr-2-1-8ef8fdec02b0b0e47240b2b00c0e69a7.jpeg";